import React from 'react';
import {
  Copy,
  Flex,
  Square,
  Stack,
  SvgCheck,
} from '@grubhubprod/gh-cookbook-react';
import { useDataTableSelectionContext } from 'src/components/DataTable/components/DataTableSelectionProvider/hooks/useDataTableSelectionContext';
import { DataTableSelectionActions } from './DataTableSelectionActions';
import { getSelectionCountText } from './dataTableSelectionActionBar.utils';

export const DataTableSelectionActionBar: React.FC = () => {
  const {
    isDirty,
    currentSelections,
    saveSelections,
    resetSelections,
    isLoading,
    entityName = 'item',
    primaryActionName,
    secondaryActionName,
    hideSelectionMessage,
  } = useDataTableSelectionContext();

  if (!isDirty) {
    return null;
  }

  const selectionText = getSelectionCountText(
    currentSelections.length,
    entityName
  );

  return (
    <Square
      inset="md"
      borderBottom="1px solid"
      borderColor="lightLine"
      backgroundColor="tintedBackground"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          {!hideSelectionMessage && (
            <>
              <Stack x="xx-sm">
                <SvgCheck color="primaryText" />
              </Stack>
              <Copy variant="body" color="primaryText">
                {selectionText}
              </Copy>
            </>
          )}
        </Flex>
        <DataTableSelectionActions
          primaryActionName={primaryActionName}
          secondaryActionName={secondaryActionName}
          onPrimaryAction={saveSelections}
          onSecondaryAction={resetSelections}
          isLoading={isLoading}
        />
      </Flex>
    </Square>
  );
};
